<script setup>
import {defineProps, defineEmits, ref, onMounted} from "vue";

const props = defineProps({
  text: Object,
  placeholder: Object
})

// const emit = defineEmits(['item-dropped', 'drop', 'delete-row', 'delete-col', 'add-col', 'add-row', 'merge-col', 'merge-row', 'split-cell']);

const openPopover = ref(false);
const popoverPosition = ref({left: '0px', top: '0px'});

const fontSizes = [];
for (let i = 4; i <= 72; i++) {
  fontSizes.push(i);
}
onMounted(() => {
  document.addEventListener('keydown', handleKeyDown);
})

function handleKeyDown(e) {
  if (e.key === 'Escape') {
    openPopover.value = false;
  }
}

function showPopover(event) {
  if (!event.target.closest('.popover')) {
    const tdRect = event.currentTarget.getBoundingClientRect();

    const relativeX = event.clientX - tdRect.left;
    const relativeY = event.clientY - tdRect.top;

    popoverPosition.value = {
      left: `${relativeX}px`,
      top: `${relativeY}px`
    };

    openPopover.value = !openPopover.value;
  }
}

function showEditForm() {
  console.log(11)
}


</script>

<template>
  <div class="cell-content" v-if="text">
      <span @dblclick.stop="text.edit=true">
        <div  class="edit" v-if="text.edit"><input type="text" v-model="text.text">

          <button class="" @click="text.edit=false"><i class="bi bi-check"></i></button>
          <button class="" @click="text.edit=false"><i class="bi bi-x-lg"></i></button>
        </div>
        <span @click="showPopover($event)"
            :style="{color: text.color, fontSize: text.font_size+'pt', fontWeight: text.bold?700:300}" v-else>{{ text.text }}</span>
      </span>

    <div class="popover" v-show="openPopover" :style="popoverPosition">
      <div class="line">
        <div class="font-size" v-if="text">
          <select name="" v-model="text.font_size" id="" title="Размер шрифта">
            <option v-for="font in fontSizes" :value="font" :key="font">{{ font }}</option>
          </select>
        </div>
        <div class="color" v-if="text">
          <input v-model="text.color" title="Цвет текста" type="color">
        </div>
        <div class="bold" v-if="text">
          <button title="Начертание" @click="text.bold = !text.bold"
                  :class="`btn btn-sm`+(text.bold?' btn-outline-dark':'')"><b>B</b></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
td {
  position: relative;
}

.cell-content {
  .edit{
    display: inline-block;
    input {
    width: auto;
    height: auto;
    padding: 0;
  }

  button {
    border: 1px solid #000;
    border-radius: 3px;
    background: #fff;
    padding: 0;
  }
  }


  span {
    color: #000;
    margin-right: 5px;
    font-size: 8pt;
    line-height: 1;
  }

  span:hover {
    background: #cecece;
    border-radius: 5px;
    cursor: pointer;
  }
}

.popover {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 3px;
  transform: translateY(10px);

  .line {
    display: flex;
    gap: 10px;

    input {
      height: 20px;
    }

    button {
      height: 20px;
      font-size: 12px;
      line-height: 12px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      font-weight: bolder;
    }
  }


}
</style>